//
//
//
//
//
//

export default {
	props: {
		href: {
			type: String,
			default: null
		}
	},
	data: function data() {
		return {};
	},

	computed: {
		type: function type() {
			if (this.href) {
				return "a";
			} else {
				return "button";
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/Btn.vue
// module id = KWp0
// module chunks = 0 1